module.exports = __webpack_public_path__ + "img/teacher-iphone.5967a933.png";